import { Card, Col, Row } from "react-bootstrap";

import BetListTable from "./components/BetListTable";
import { useBetQuery } from "../../graphql/apollo/query-hooks";

const Bet = () => {
  const { getBetListAdmin, loading } = useBetQuery();

  return (
    <Row className="lao">
      <Col lg={12}>
        <Card>
          <Card.Header>
            <Card.Title>
              <h3 className="p-1">ລາຍການຂໍ້ມູນເດີມພັນ</h3>
            </Card.Title>
          </Card.Header>
          <Card.Body>
            <BetListTable data={getBetListAdmin} loading={loading} />
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default Bet;
